<template>
  <div>
    <MerchantHome v-if="get_user.lead_type == 1" />
    <IndividualHome v-else />
  </div>
</template>
<script>
import commonAllMixins from "@/plugins/commonAll";
import IndividualHome from "./individual_home";
import MerchantHome from "./merchant_home";

export default {
  mixins: [commonAllMixins],
  components: { IndividualHome, MerchantHome },
  watch: {
    profileInfo(val) {
      if (this.get_user.lead_type)
        this.pageName(
          val.legal_name
            ? `${val.legal_name}'s Dashboard`
            : val.firstname
            ? `${val.firstname}'s Dashboard`
            : "Dashboard"
        );
    },
  },
  created() {
    this.pageName("Dashboard");
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/user/home.vue